// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminModal_wrap__Ob8s5 {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1000;
    overflow: hidden;
}

.AdminModal_container__9vT08 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #FFFFFF;
}

.AdminModal_topContainer__sb6BS {
    background-color: #E63131;
    width: inherit;
    height: 64px;
    color: #FFFFFF;
    font-size: 28px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    padding: 0 24px 0 40px;
    align-items: center;
}

.AdminModal_topContainer__sb6BS img {
    width: 24px;
    cursor: pointer;
}

.AdminModal_middleContainer__l4yU7 {
    padding: 0 40px;
}

.AdminModal_bottomContainer__Saw2L {
    background-color: #F4F4F4;
    width: inherit;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.AdminModal_actionButton__8Dn1s {
    width: 198px;
    height: 64px;
    border-radius: 36px;
    background-color: #E63131;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.AdminModal_actionButton2__mw3O9 {
    border-radius: 28px;
    background-color: #E63131;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.AdminModal_themeContainer__0UBOc {
    padding-top: 23px;
    display: flex;
    flex-direction: column;
    gap: 23px;
}

.AdminModal_middleTheme__i0HWR {
    color: #434343;
    font-size: 24px;
    font-weight: 600;
}

.AdminModal_middleLine__NCnOj {
    width: 100%;
    height: 1px;
    border: none;
    margin: 0;
    background-color: #DDDDDD;
}

.AdminModal_contentContainer__1TCz4 {
    padding: 32px 0 38px;
}

.AdminModal_plusShape__sDMUc {
    height: 4px;
    width: 100%;
    margin: 0;
    position: absolute;
    border: none;
    background-color: #707070;
}

.AdminModal_plusShape__sDMUc:nth-child(2) {
    rotate: 90deg;
}

.AdminModal_plusMent__ySxS7 {
    font-size: 18px;
    color: #A2A2A2;
}

/* AdminLogin */
.AdminModal_login__qtTZg {
    width: 640px;
    height: 376px;
}

.AdminModal_middleLogin__-r4R6 {
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
}

.AdminModal_loginTextbox__mp-6J {
    width: 320px;
    height: 48px;
    padding: 14px 18px;
    border: 1px solid #DDDDDD;
    color: #222222;
    font-size: 18px;
    font-weight: 500;
}

.AdminModal_loginTextbox__mp-6J:focus,
.AdminModal_loginTextbox__mp-6J:not(:placeholder-shown) {
    border: 1px solid #DC140A;
    outline: none;
}

/* Main */
.AdminModal_introMainBtn__Gcb73 {
    position: absolute;
    top: -80px;
    width: 200px;
}

.AdminModal_main__3Jb4z {
    width: 1300px;
    height: 795px;
}

.AdminModal_mainContent__kc\\+gX {
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
}

.AdminModal_mainImgBox__42SfF {
    width: 860px;
    height: 402px;
    background-color: #F4F4F4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.AdminModal_mainImgBox__42SfF img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 860px;
    height: 402px;
    display: block;
}

.AdminModal_mainPlus__gv1vl {
    width: 50px;
    height: 50px;
    position: relative;
}

.AdminModal_mainButtonBox__S7F4Z {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.AdminModal_fncMainBtn__0GjI4 {
    width: 104px;
    height: 48px;
}

input[type=file] {
    display: none;
}

/* Production */
.AdminModal_introProductionBtn__F4sIX {
    width: 200px;
    position: absolute;
    bottom: -96px;
    left: 50%;
    transform: translateX(-50%);
}

.AdminModal_production__e77sX {
    width: 1300px;
    height: 856px;
}

.AdminModal_middleProductionWrap__PSVeV {
    display: flex;
    gap: 20px;
}

.AdminModal_middleProduction__9ndfM:nth-child(1) {
    width: 270px;
}

.AdminModal_middleProduction__9ndfM:nth-child(2) {
    width: 930px;
}

.AdminModal_productionContent__0u\\+0L {
    padding: 32px 0 40px;
    display: flex;
    flex-direction: column;
    gap: 23px;
}

.AdminModal_productionListContainer__kDzgg {
    width: 100%;
    height: 445px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-x: hidden;
    overflow-y: overlay;
}

.AdminModal_productionListItem__gM0Zu {
    height: 48px;
    border: 1px solid #DDDDDD;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
    position: relative;
    transition: 0.3s ease-out;
}

.AdminModal_productionListItem__gM0Zu:hover {
    background-color: #DDDDDD;
}

.AdminModal_productionListItem__gM0Zu:hover > .AdminModal_deleteItemBtn__eisd1 {
    opacity: 1;
    visibility: visible;
}


.AdminModal_selected__CPYH8 {
    background-color: #DDDDDD;
}

.AdminModal_selected__CPYH8 > .AdminModal_productionListItemNum__gdTLK,
.AdminModal_selected__CPYH8 > .AdminModal_productionListItemName__itfsn {
    color: #1C1C1D;
}

.AdminModal_selected__CPYH8 > .AdminModal_deleteItemBtn__eisd1 {
    opacity: 1;
    visibility: visible;
}

.AdminModal_productionListItemNum__gdTLK {
    color: #A2A2A2;
    font-size: 18px;
    font-weight: 600;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #DDDDDD;
    flex-shrink: 0;
}

.AdminModal_productionListItemName__itfsn {
    color: #A2A2A2;
    font-size: 18px;
    padding: 0 22px;
    max-width: 222px;
    flex-shrink: 0;
}

.AdminModal_productionListItemName__itfsn > span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
}

.AdminModal_fncProductionBtn__aPGCu {
    height: 48px;
}

.AdminModal_productionContent2__V4P7e {
    display: flex;
    gap: 40px;
    padding: 32px 0 35px;
}

.AdminModal_productionContentInfo__65sPR {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 534px;
    overflow-x: hidden;
    overflow-y: auto;
}

.AdminModal_productionContentImage__KOzpR {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.AdminModal_contentInfoContainer__idT\\+1 {
    width: 400px;
}

.AdminModal_contentImageContainer__ijR-T {
    width: 310px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.AdminModal_productionContentTheme__J7kc0 {
    color: #434343;
    font-size: 20px;
    font-weight: 600;
    width: 110px;
    position: relative;
}

.AdminModal_productionContentMent__3hFhW {
    color: #A2A2A2;
    font-size: 14px;
    letter-spacing: -0.14px;
}

.AdminModal_infoItemContainer__YMSZl {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.AdminModal_infoItem__tlDn4 {
    border: 1px solid #DDDDDD;
    height: 48px;
    display: flex;
    padding: 0 16px;
    align-items: center;
    gap: 40px;
}
.AdminModal_infoItem__tlDn4 > span {
    color: #a2a2a2;
    font-size: 16px;
    font-weight: 500;
    position: relative;
}

.AdminModal_infoItem__tlDn4 > input[type=text] {
    outline: none;
    border: transparent;
    height: 40px;
    font-size: 18px;
    color: #434343;
    font-weight: 600;
}

.AdminModal_infoItem__tlDn4 input[type=text]::placeholder {
    color: #A2A2A2;
    font-weight: 400;
}

.AdminModal_required__WBXTo {
    display: block;
    font-size: 9px;
    font-weight: 500;
    color: #E63131;
    position: absolute;
    top: 0;
    right: -24px;
}

.AdminModal_imfoImage__vAlM- {

}

.AdminModal_productionImage__sN95S {
    width: 310px;
    height: 465px;
    background-color: #F4F4F4;
    display: flex;
    flex-direction: column;
    gap: 13px;
    justify-content: center;
    align-items: center;
    position: relative;
}

.AdminModal_productionPlus__-Cflz {
    width: 37px;
    height: 37px;
    position: relative;
    cursor: pointer;
}
.AdminModal_productionImage__sN95S > span {
    font-size: 13px;
    padding: 0 29px;
    text-align: center;
}

.AdminModal_deleteItemBtn__eisd1 {
    background-color: #E63131;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 40%;
    right: 28px;
    transform: translateY(-40%);
    rotate: 45deg;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s ease-out;
    cursor: pointer;
}

.AdminModal_deleteItemBtn__eisd1 > div {
    width: 10px;
    height: 10px;
    position: relative;
    margin-top: 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.AdminModal_deleteItemBtn__eisd1 > div > hr {
    width: 100%;
    height: 1px;
    background-color: #FFFFFF;
    margin: 0;
    border: none;
    position: absolute;
}

.AdminModal_deleteItemBtn__eisd1 > div > hr:nth-child(2) {
    rotate: 90deg;
}

.AdminModal_productionImage__sN95S > img {
    position: absolute;
    top: 0;
    width: 310px;
    z-index: 1;
    cursor: pointer;
}

.AdminModal_isalbum__viRdH,
.AdminModal_isalbum__viRdH > img {
    height: 310px;
}

/* NEWS */
.AdminModal_introNewsBtn__u601z {
    margin: 40px auto 0 auto;
}

.AdminModal_news__UZhnl {
    width: 1300px;
    height: 979px;
}

.AdminModal_notice__F5EN- {
    width: 1300px;
    height: 939px;
}

.AdminModal_newsContent__HE0-P {
    margin: 32px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 24px 20px;
}

.AdminModal_newsContentItem__MMl74 {
    width: 600px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.AdminModal_newsContentThemeContainer__RuYyZ {
    display: flex;
    align-items: center;
    gap: 32px;
}

.AdminModal_newsContentTheme__e-1DT {
    color: #434343;
    font-size: 20px;
    font-weight: 600;
    position: relative;
}

.AdminModal_newsContentexplain__kcOh5 {
    color: #A2A2A2;
    font-size: 14px;
}

.AdminModal_requirednews__Ugryr {
    display: block;
    font-size: 9px;
    font-weight: 500;
    color: #E63131;
    position: absolute;
    top: 0;
    right: -28px;
}

.AdminModal_newsContentItem__MMl74 input[type=text] {
    outline: none;
    border: 1px solid #DDDDDD;
    height: 48px;
    padding: 0 16px;
    color: #434343;
    font-size: 18px;
    font-weight: 600;
}

.AdminModal_newsContentItem__MMl74 input[type=text]::placeholder {
    color: #A2A2A2;
    font-weight: 400;
}

.AdminModal_newsContentItem__MMl74 textarea {
    height: 160px !important;
    outline: none;
    border: 1px solid #DDDDDD;
    padding: 14px 16px;
    color: #434343;
    font-size: 14px;
    resize: none;
}

.AdminModal_newsImgContainer__3ey-z {
    padding: 32px 0 40px 0;
    display: flex;
    gap: 24px;
}

.AdminModal_newsImgContainer__3ey-z > .AdminModal_newsContentThemeContainer__RuYyZ {
    flex-direction: column;
    align-items: baseline;
    gap: 7px;
}

.AdminModal_newsImgAddBtn__uWNU6 {
    width: 104px;
    height: 48px;
    font-size: 14px;
}

.AdminModal_newsUploadImg__NPM8h {
    border-radius: 8px;
    background-color: #F4F4F4;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.AdminModal_newsUploadImg__NPM8h > span {
    color: #1C1C1D;
    font-size: 14px;
}

.AdminModal_newsUploadImgDelBtn__w6bh- {
    background-color: #DDDDDD;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    rotate: 45deg;
    cursor: pointer;
}

.AdminModal_newsUploadImgDelBtn__w6bh- > hr {
    margin: 0;
    width: 8px;
    height: 1px;
    border: none;
    background-color: #707070;
    position: absolute;
    top: 50%;
    left: 50;
}

.AdminModal_newsUploadImgDelBtn__w6bh- > hr:nth-child(2) {
    rotate: 90deg;
}

.AdminModal_newsFileContainer__Oxjjd {
    margin-top: -16px;
    padding-bottom: 40px;
    display: flex;
    gap: 24px;
}

.AdminModal_newsFileContainer__Oxjjd > .AdminModal_newsContentThemeContainer__RuYyZ {
    flex-direction: column;
    align-items: baseline;
    gap: 7px;
}

/* More */

.AdminModal_introMoreContainer__nfeaY {
    margin-top: -40px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;
}

/* Artist */
.AdminModal_introArtistContainer__cMNg7 {
    margin-top: 40px;
    display: flex;
    justify-content: center;
}

.AdminModal_artist__7wiAg {
    width: 1300px;
    max-height: 95vh;
}

.AdminModal_middleArtistWrap__FseUU {
    display: flex;
    gap: 20px;
}

.AdminModal_middleArtist__c\\+8Gj:nth-child(1) {
    width: 270px;
}

.AdminModal_middleArtist__c\\+8Gj:nth-child(2) {
    width: 930px;
}

.AdminModal_artistContent__d0bXi {
    padding: 32px 0 40px;
    display: flex;
    flex-direction: column;
    gap: 23px;
}

.AdminModal_artistListContainer__44syX {
    width: 100%;
    height: 445px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-x: hidden;
    overflow-y: overlay;
}

.AdminModal_artistListItem__7E2uA {
    height: 48px;
    border: 1px solid #DDDDDD;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
    position: relative;
    transition: 0.3s ease-out;
}

.AdminModal_artistListItem__7E2uA:hover {
    background-color: #DDDDDD;
}

.AdminModal_artistListItem__7E2uA:hover > .AdminModal_deleteItemBtn__eisd1 {
    opacity: 1;
    visibility: visible;
}


.AdminModal_selected__CPYH8 > .AdminModal_artistListItemNum__yxj62,
.AdminModal_selected__CPYH8 > .AdminModal_artistListItemName__ZRZdA {
    color: #1C1C1D;
}

.AdminModal_artistListItemNum__yxj62 {
    color: #A2A2A2;
    font-size: 18px;
    font-weight: 600;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #DDDDDD;
    flex-shrink: 0;
}

.AdminModal_artistListItemName__ZRZdA {
    color: #A2A2A2;
    font-size: 18px;
    padding: 0 22px;
    max-width: 222px;
    flex-shrink: 0;
}

.AdminModal_artistListItemName__ZRZdA > span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
}

.AdminModal_artistContent2__5os1W {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 32px 0 35px;
    height: 660px;
    overflow-y: scroll;
}

.AdminModal_artistContent2__5os1W::-webkit-scrollbar {
    display: none;
}

.AdminModal_artistContentInfo__\\+L850 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 400px;
}

.AdminModal_artistContentInfoContainer__IEuSi {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.AdminModal_artistContentTheme__jXWyR {
    color: #434343;
    font-size: 20px;
    font-weight: 600;
    width: 110px;
    position: relative;
}

.AdminModal_aritstContentExplain__94hHK {
    color: #A2A2A2;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    flex-direction: column;
}

.AdminModal_aritstContentExplain__94hHK > span {
    display: block;
}

.AdminModal_artistContentImage__RL4y3 {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.AdminModal_artistImgContainer__tf3RB {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}

.AdminModal_artistImgItem__gZMpS {
    background-color: #F4F4F4;
    width: 80px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
}

.AdminModal_artistImgItem__gZMpS:nth-child(1) > .AdminModal_artistImgWithDel__-bOSJ > img {
    border: 1px solid #000000;
}

.AdminModal_artistImgWithDel__-bOSJ > img {
    width: 80px;
    height: 120px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    cursor: pointer;
    transition: 0.3s ease-out;
    color: transparent;
}

.AdminModal_artistImgWithDel__-bOSJ:hover > img {
    filter: brightness(30%);
}

.AdminModal_artistImgWithDel__-bOSJ:hover > .AdminModal_deleteItemBtn__eisd1 {
    visibility: visible;
    opacity: 1;
}

.AdminModal_artistImgWithDel__-bOSJ > .AdminModal_deleteItemBtn__eisd1 {
    transform: translateY(0);
    z-index: 5;
}

.AdminModal_itemNameTag__fcmp6 {
    height: 24px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #1C1C1D;
    color: #F4F4F4;
    font-size: 14px;
    font-weight: 500;
    z-index: 2;
}

.AdminModal_artistImgItem__gZMpS:nth-child(n+2) > .AdminModal_itemNameTag__fcmp6 {
    max-width: 24px;
}

.AdminModal_artistPlus__KOUSN {
    width: 16px;
    height: 16px;
    position: relative;
    margin-top: 16px;
}

.AdminModal_plusShape2__8rPuJ {
    height: 2px;
    width: 100%;
    margin: 0;
    position: absolute;
    border: none;
    background-color: #707070;
}

.AdminModal_plusShape2__8rPuJ:nth-child(2) {
    rotate: 90deg;
}

.AdminModal_artistContentCareer__\\+oPM- {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 13px;
}

.AdminModal_artistCareerContainer__lElsF {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
}

.AdminModal_artistCareerItem__nnTZX {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.AdminModal_artistCareerItem__nnTZX > span {
    color: #434343;
    font-size: 16px;
    font-weight: 600;
}

.AdminModal_artistCareerTextarea__xsZ8K {
    width: 440px;
    height: 93px;
    padding: 16px;
    border: 1px solid #DDDDDD;
}

.AdminModal_artistCareerTextarea__xsZ8K > textarea {
    width: 408px;
    height: 61px;
    color: #434343;
    font-size: 14px;
    outline: none;
    resize: none;
    border: none;
    line-height: 22px;
}

.AdminModal_contentImageContainer2__R12Vr {
    width: 330px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.AdminModal_productionContentTheme2__t4Aaw {
    color: #434343;
    font-size: 20px;
    font-weight: 600;
    width: 126px;
    position: relative;
}

.AdminModal_producerImage__onvhD {
    width: 160px;
    height: 160px;
    background-color: #F4F4F4;
    display: flex;
    flex-direction: column;
    gap: 13px;
    justify-content: center;
    align-items: center;
    position: relative;
}

.AdminModal_producerImage__onvhD > img {
    position: absolute;
    top: 0;
    width: 160px;
    z-index: 1;
    cursor: pointer;
}

.AdminModal_productionContentInfo2__8Dn\\+6 {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 279px;
    overflow-x: hidden;
    overflow-y: auto;
}

.AdminModal_productionContent3__1EiSe {
    display: flex;
    gap: 0 134px;
    padding: 32px 0 35px;
    flex-wrap: wrap;
}

.AdminModal_productionContent3__1EiSe > hr {
    width: 100%;
    height: 1px;
    border: none;
    background-color: #DDDDDD;
    margin: 16px 0;
}

.AdminModal_productionContent3__1EiSe .AdminModal_infoItem__tlDn4 {
    width: 440px;
}

.AdminModal_productionContent3__1EiSe .AdminModal_infoItem__tlDn4 input[type=text] {
    width: 310px;
}
.AdminModal_productionContentMent2__q9ycL {
    display: block;
    color: #A2A2A2;
    font-size: 14px;
    letter-spacing: -0.14px;
    margin-top: 8px;
}

.AdminModal_producerTextContainer__2yC5m {
    width: 904px;
    display: flex;
    gap: 24px;
    margin-top: 16px;
}

.AdminModal_producerItem__yP50W {
    width: 440px;
}

.AdminModal_producerItem__yP50W > span {
    display: block;
    color: #434343;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
}

.AdminModal_producerItem__yP50W > textarea {
    width: 440px;
    height: 93px;
    color: #434343;
    font-size: 14px;
    outline: none;
    resize: none;
    border: 1px solid #DDDDDD;
    line-height: 22px;
    letter-spacing: -0.14px;
    padding: 16px;
}

.AdminModal_producerPlus__DdSFb {
    width: 37px;
    height: 37px;
    position: relative;
    transform: translateY(18px);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/AdminModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,MAAM;IACN,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;AACjB;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;;AAEA;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA,SAAS;AACT;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA,SAAS;;AAET;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;;AAGA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB","sourcesContent":[".wrap {\n    position: fixed;\n    background-color: rgba(0, 0, 0, 0.7);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    z-index: 1000;\n    overflow: hidden;\n}\n\n.container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #FFFFFF;\n}\n\n.topContainer {\n    background-color: #E63131;\n    width: inherit;\n    height: 64px;\n    color: #FFFFFF;\n    font-size: 28px;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 24px 0 40px;\n    align-items: center;\n}\n\n.topContainer img {\n    width: 24px;\n    cursor: pointer;\n}\n\n.middleContainer {\n    padding: 0 40px;\n}\n\n.bottomContainer {\n    background-color: #F4F4F4;\n    width: inherit;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.actionButton {\n    width: 198px;\n    height: 64px;\n    border-radius: 36px;\n    background-color: #E63131;\n    color: #FFFFFF;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.actionButton2 {\n    border-radius: 28px;\n    background-color: #E63131;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.themeContainer {\n    padding-top: 23px;\n    display: flex;\n    flex-direction: column;\n    gap: 23px;\n}\n\n.middleTheme {\n    color: #434343;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.middleLine {\n    width: 100%;\n    height: 1px;\n    border: none;\n    margin: 0;\n    background-color: #DDDDDD;\n}\n\n.contentContainer {\n    padding: 32px 0 38px;\n}\n\n.plusShape {\n    height: 4px;\n    width: 100%;\n    margin: 0;\n    position: absolute;\n    border: none;\n    background-color: #707070;\n}\n\n.plusShape:nth-child(2) {\n    rotate: 90deg;\n}\n\n.plusMent {\n    font-size: 18px;\n    color: #A2A2A2;\n}\n\n/* AdminLogin */\n.login {\n    width: 640px;\n    height: 376px;\n}\n\n.middleLogin {\n    padding: 40px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n}\n\n.loginTextbox {\n    width: 320px;\n    height: 48px;\n    padding: 14px 18px;\n    border: 1px solid #DDDDDD;\n    color: #222222;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.loginTextbox:focus,\n.loginTextbox:not(:placeholder-shown) {\n    border: 1px solid #DC140A;\n    outline: none;\n}\n\n/* Main */\n.introMainBtn {\n    position: absolute;\n    top: -80px;\n    width: 200px;\n}\n\n.main {\n    width: 1300px;\n    height: 795px;\n}\n\n.mainContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    justify-content: center;\n    align-items: center;\n}\n\n.mainImgBox {\n    width: 860px;\n    height: 402px;\n    background-color: #F4F4F4;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.mainImgBox img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 860px;\n    height: 402px;\n    display: block;\n}\n\n.mainPlus {\n    width: 50px;\n    height: 50px;\n    position: relative;\n}\n\n.mainButtonBox {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.fncMainBtn {\n    width: 104px;\n    height: 48px;\n}\n\ninput[type=file] {\n    display: none;\n}\n\n/* Production */\n.introProductionBtn {\n    width: 200px;\n    position: absolute;\n    bottom: -96px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.production {\n    width: 1300px;\n    height: 856px;\n}\n\n.middleProductionWrap {\n    display: flex;\n    gap: 20px;\n}\n\n.middleProduction:nth-child(1) {\n    width: 270px;\n}\n\n.middleProduction:nth-child(2) {\n    width: 930px;\n}\n\n.productionContent {\n    padding: 32px 0 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 23px;\n}\n\n.productionListContainer {\n    width: 100%;\n    height: 445px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow-x: hidden;\n    overflow-y: overlay;\n}\n\n.productionListItem {\n    height: 48px;\n    border: 1px solid #DDDDDD;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    cursor: pointer;\n    position: relative;\n    transition: 0.3s ease-out;\n}\n\n.productionListItem:hover {\n    background-color: #DDDDDD;\n}\n\n.productionListItem:hover > .deleteItemBtn {\n    opacity: 1;\n    visibility: visible;\n}\n\n\n.selected {\n    background-color: #DDDDDD;\n}\n\n.selected > .productionListItemNum,\n.selected > .productionListItemName {\n    color: #1C1C1D;\n}\n\n.selected > .deleteItemBtn {\n    opacity: 1;\n    visibility: visible;\n}\n\n.productionListItemNum {\n    color: #A2A2A2;\n    font-size: 18px;\n    font-weight: 600;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid #DDDDDD;\n    flex-shrink: 0;\n}\n\n.productionListItemName {\n    color: #A2A2A2;\n    font-size: 18px;\n    padding: 0 22px;\n    max-width: 222px;\n    flex-shrink: 0;\n}\n\n.productionListItemName > span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fncProductionBtn {\n    height: 48px;\n}\n\n.productionContent2 {\n    display: flex;\n    gap: 40px;\n    padding: 32px 0 35px;\n}\n\n.productionContentInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    height: 534px;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.productionContentImage {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.contentInfoContainer {\n    width: 400px;\n}\n\n.contentImageContainer {\n    width: 310px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.productionContentTheme {\n    color: #434343;\n    font-size: 20px;\n    font-weight: 600;\n    width: 110px;\n    position: relative;\n}\n\n.productionContentMent {\n    color: #A2A2A2;\n    font-size: 14px;\n    letter-spacing: -0.14px;\n}\n\n.infoItemContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.infoItem {\n    border: 1px solid #DDDDDD;\n    height: 48px;\n    display: flex;\n    padding: 0 16px;\n    align-items: center;\n    gap: 40px;\n}\n.infoItem > span {\n    color: #a2a2a2;\n    font-size: 16px;\n    font-weight: 500;\n    position: relative;\n}\n\n.infoItem > input[type=text] {\n    outline: none;\n    border: transparent;\n    height: 40px;\n    font-size: 18px;\n    color: #434343;\n    font-weight: 600;\n}\n\n.infoItem input[type=text]::placeholder {\n    color: #A2A2A2;\n    font-weight: 400;\n}\n\n.required {\n    display: block;\n    font-size: 9px;\n    font-weight: 500;\n    color: #E63131;\n    position: absolute;\n    top: 0;\n    right: -24px;\n}\n\n.imfoImage {\n\n}\n\n.productionImage {\n    width: 310px;\n    height: 465px;\n    background-color: #F4F4F4;\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.productionPlus {\n    width: 37px;\n    height: 37px;\n    position: relative;\n    cursor: pointer;\n}\n.productionImage > span {\n    font-size: 13px;\n    padding: 0 29px;\n    text-align: center;\n}\n\n.deleteItemBtn {\n    background-color: #E63131;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 40%;\n    right: 28px;\n    transform: translateY(-40%);\n    rotate: 45deg;\n    opacity: 0;\n    visibility: hidden;\n    transition: 0.3s ease-out;\n    cursor: pointer;\n}\n\n.deleteItemBtn > div {\n    width: 10px;\n    height: 10px;\n    position: relative;\n    margin-top: 5px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.deleteItemBtn > div > hr {\n    width: 100%;\n    height: 1px;\n    background-color: #FFFFFF;\n    margin: 0;\n    border: none;\n    position: absolute;\n}\n\n.deleteItemBtn > div > hr:nth-child(2) {\n    rotate: 90deg;\n}\n\n.productionImage > img {\n    position: absolute;\n    top: 0;\n    width: 310px;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.isalbum,\n.isalbum > img {\n    height: 310px;\n}\n\n/* NEWS */\n.introNewsBtn {\n    margin: 40px auto 0 auto;\n}\n\n.news {\n    width: 1300px;\n    height: 979px;\n}\n\n.notice {\n    width: 1300px;\n    height: 939px;\n}\n\n.newsContent {\n    margin: 32px 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px 20px;\n}\n\n.newsContentItem {\n    width: 600px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.newsContentThemeContainer {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n}\n\n.newsContentTheme {\n    color: #434343;\n    font-size: 20px;\n    font-weight: 600;\n    position: relative;\n}\n\n.newsContentexplain {\n    color: #A2A2A2;\n    font-size: 14px;\n}\n\n.requirednews {\n    display: block;\n    font-size: 9px;\n    font-weight: 500;\n    color: #E63131;\n    position: absolute;\n    top: 0;\n    right: -28px;\n}\n\n.newsContentItem input[type=text] {\n    outline: none;\n    border: 1px solid #DDDDDD;\n    height: 48px;\n    padding: 0 16px;\n    color: #434343;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.newsContentItem input[type=text]::placeholder {\n    color: #A2A2A2;\n    font-weight: 400;\n}\n\n.newsContentItem textarea {\n    height: 160px !important;\n    outline: none;\n    border: 1px solid #DDDDDD;\n    padding: 14px 16px;\n    color: #434343;\n    font-size: 14px;\n    resize: none;\n}\n\n.newsImgContainer {\n    padding: 32px 0 40px 0;\n    display: flex;\n    gap: 24px;\n}\n\n.newsImgContainer > .newsContentThemeContainer {\n    flex-direction: column;\n    align-items: baseline;\n    gap: 7px;\n}\n\n.newsImgAddBtn {\n    width: 104px;\n    height: 48px;\n    font-size: 14px;\n}\n\n.newsUploadImg {\n    border-radius: 8px;\n    background-color: #F4F4F4;\n    padding: 16px 20px;\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.newsUploadImg > span {\n    color: #1C1C1D;\n    font-size: 14px;\n}\n\n.newsUploadImgDelBtn {\n    background-color: #DDDDDD;\n    border-radius: 50%;\n    width: 16px;\n    height: 16px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    rotate: 45deg;\n    cursor: pointer;\n}\n\n.newsUploadImgDelBtn > hr {\n    margin: 0;\n    width: 8px;\n    height: 1px;\n    border: none;\n    background-color: #707070;\n    position: absolute;\n    top: 50%;\n    left: 50;\n}\n\n.newsUploadImgDelBtn > hr:nth-child(2) {\n    rotate: 90deg;\n}\n\n.newsFileContainer {\n    margin-top: -16px;\n    padding-bottom: 40px;\n    display: flex;\n    gap: 24px;\n}\n\n.newsFileContainer > .newsContentThemeContainer {\n    flex-direction: column;\n    align-items: baseline;\n    gap: 7px;\n}\n\n/* More */\n\n.introMoreContainer {\n    margin-top: -40px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n/* Artist */\n.introArtistContainer {\n    margin-top: 40px;\n    display: flex;\n    justify-content: center;\n}\n\n.artist {\n    width: 1300px;\n    max-height: 95vh;\n}\n\n.middleArtistWrap {\n    display: flex;\n    gap: 20px;\n}\n\n.middleArtist:nth-child(1) {\n    width: 270px;\n}\n\n.middleArtist:nth-child(2) {\n    width: 930px;\n}\n\n.artistContent {\n    padding: 32px 0 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 23px;\n}\n\n.artistListContainer {\n    width: 100%;\n    height: 445px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow-x: hidden;\n    overflow-y: overlay;\n}\n\n.artistListItem {\n    height: 48px;\n    border: 1px solid #DDDDDD;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    cursor: pointer;\n    position: relative;\n    transition: 0.3s ease-out;\n}\n\n.artistListItem:hover {\n    background-color: #DDDDDD;\n}\n\n.artistListItem:hover > .deleteItemBtn {\n    opacity: 1;\n    visibility: visible;\n}\n\n\n.selected > .artistListItemNum,\n.selected > .artistListItemName {\n    color: #1C1C1D;\n}\n\n.artistListItemNum {\n    color: #A2A2A2;\n    font-size: 18px;\n    font-weight: 600;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-right: 1px solid #DDDDDD;\n    flex-shrink: 0;\n}\n\n.artistListItemName {\n    color: #A2A2A2;\n    font-size: 18px;\n    padding: 0 22px;\n    max-width: 222px;\n    flex-shrink: 0;\n}\n\n.artistListItemName > span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.artistContent2 {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding: 32px 0 35px;\n    height: 660px;\n    overflow-y: scroll;\n}\n\n.artistContent2::-webkit-scrollbar {\n    display: none;\n}\n\n.artistContentInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 400px;\n}\n\n.artistContentInfoContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.artistContentTheme {\n    color: #434343;\n    font-size: 20px;\n    font-weight: 600;\n    width: 110px;\n    position: relative;\n}\n\n.aritstContentExplain {\n    color: #A2A2A2;\n    font-size: 14px;\n    line-height: 22px;\n    display: flex;\n    flex-direction: column;\n}\n\n.aritstContentExplain > span {\n    display: block;\n}\n\n.artistContentImage {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.artistImgContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 14px;\n}\n\n.artistImgItem {\n    background-color: #F4F4F4;\n    width: 80px;\n    height: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n}\n\n.artistImgItem:nth-child(1) > .artistImgWithDel > img {\n    border: 1px solid #000000;\n}\n\n.artistImgWithDel > img {\n    width: 80px;\n    height: 120px;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    cursor: pointer;\n    transition: 0.3s ease-out;\n    color: transparent;\n}\n\n.artistImgWithDel:hover > img {\n    filter: brightness(30%);\n}\n\n.artistImgWithDel:hover > .deleteItemBtn {\n    visibility: visible;\n    opacity: 1;\n}\n\n.artistImgWithDel > .deleteItemBtn {\n    transform: translateY(0);\n    z-index: 5;\n}\n\n.itemNameTag {\n    height: 24px;\n    padding: 0 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #1C1C1D;\n    color: #F4F4F4;\n    font-size: 14px;\n    font-weight: 500;\n    z-index: 2;\n}\n\n.artistImgItem:nth-child(n+2) > .itemNameTag {\n    max-width: 24px;\n}\n\n.artistPlus {\n    width: 16px;\n    height: 16px;\n    position: relative;\n    margin-top: 16px;\n}\n\n.plusShape2 {\n    height: 2px;\n    width: 100%;\n    margin: 0;\n    position: absolute;\n    border: none;\n    background-color: #707070;\n}\n\n.plusShape2:nth-child(2) {\n    rotate: 90deg;\n}\n\n.artistContentCareer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 13px;\n}\n\n.artistCareerContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px 24px;\n}\n\n.artistCareerItem {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.artistCareerItem > span {\n    color: #434343;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.artistCareerTextarea {\n    width: 440px;\n    height: 93px;\n    padding: 16px;\n    border: 1px solid #DDDDDD;\n}\n\n.artistCareerTextarea > textarea {\n    width: 408px;\n    height: 61px;\n    color: #434343;\n    font-size: 14px;\n    outline: none;\n    resize: none;\n    border: none;\n    line-height: 22px;\n}\n\n.contentImageContainer2 {\n    width: 330px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.productionContentTheme2 {\n    color: #434343;\n    font-size: 20px;\n    font-weight: 600;\n    width: 126px;\n    position: relative;\n}\n\n.producerImage {\n    width: 160px;\n    height: 160px;\n    background-color: #F4F4F4;\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.producerImage > img {\n    position: absolute;\n    top: 0;\n    width: 160px;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.productionContentInfo2 {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    height: 279px;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.productionContent3 {\n    display: flex;\n    gap: 0 134px;\n    padding: 32px 0 35px;\n    flex-wrap: wrap;\n}\n\n.productionContent3 > hr {\n    width: 100%;\n    height: 1px;\n    border: none;\n    background-color: #DDDDDD;\n    margin: 16px 0;\n}\n\n.productionContent3 .infoItem {\n    width: 440px;\n}\n\n.productionContent3 .infoItem input[type=text] {\n    width: 310px;\n}\n.productionContentMent2 {\n    display: block;\n    color: #A2A2A2;\n    font-size: 14px;\n    letter-spacing: -0.14px;\n    margin-top: 8px;\n}\n\n.producerTextContainer {\n    width: 904px;\n    display: flex;\n    gap: 24px;\n    margin-top: 16px;\n}\n\n.producerItem {\n    width: 440px;\n}\n\n.producerItem > span {\n    display: block;\n    color: #434343;\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.producerItem > textarea {\n    width: 440px;\n    height: 93px;\n    color: #434343;\n    font-size: 14px;\n    outline: none;\n    resize: none;\n    border: 1px solid #DDDDDD;\n    line-height: 22px;\n    letter-spacing: -0.14px;\n    padding: 16px;\n}\n\n.producerPlus {\n    width: 37px;\n    height: 37px;\n    position: relative;\n    transform: translateY(18px);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `AdminModal_wrap__Ob8s5`,
	"container": `AdminModal_container__9vT08`,
	"topContainer": `AdminModal_topContainer__sb6BS`,
	"middleContainer": `AdminModal_middleContainer__l4yU7`,
	"bottomContainer": `AdminModal_bottomContainer__Saw2L`,
	"actionButton": `AdminModal_actionButton__8Dn1s`,
	"actionButton2": `AdminModal_actionButton2__mw3O9`,
	"themeContainer": `AdminModal_themeContainer__0UBOc`,
	"middleTheme": `AdminModal_middleTheme__i0HWR`,
	"middleLine": `AdminModal_middleLine__NCnOj`,
	"contentContainer": `AdminModal_contentContainer__1TCz4`,
	"plusShape": `AdminModal_plusShape__sDMUc`,
	"plusMent": `AdminModal_plusMent__ySxS7`,
	"login": `AdminModal_login__qtTZg`,
	"middleLogin": `AdminModal_middleLogin__-r4R6`,
	"loginTextbox": `AdminModal_loginTextbox__mp-6J`,
	"introMainBtn": `AdminModal_introMainBtn__Gcb73`,
	"main": `AdminModal_main__3Jb4z`,
	"mainContent": `AdminModal_mainContent__kc+gX`,
	"mainImgBox": `AdminModal_mainImgBox__42SfF`,
	"mainPlus": `AdminModal_mainPlus__gv1vl`,
	"mainButtonBox": `AdminModal_mainButtonBox__S7F4Z`,
	"fncMainBtn": `AdminModal_fncMainBtn__0GjI4`,
	"introProductionBtn": `AdminModal_introProductionBtn__F4sIX`,
	"production": `AdminModal_production__e77sX`,
	"middleProductionWrap": `AdminModal_middleProductionWrap__PSVeV`,
	"middleProduction": `AdminModal_middleProduction__9ndfM`,
	"productionContent": `AdminModal_productionContent__0u+0L`,
	"productionListContainer": `AdminModal_productionListContainer__kDzgg`,
	"productionListItem": `AdminModal_productionListItem__gM0Zu`,
	"deleteItemBtn": `AdminModal_deleteItemBtn__eisd1`,
	"selected": `AdminModal_selected__CPYH8`,
	"productionListItemNum": `AdminModal_productionListItemNum__gdTLK`,
	"productionListItemName": `AdminModal_productionListItemName__itfsn`,
	"fncProductionBtn": `AdminModal_fncProductionBtn__aPGCu`,
	"productionContent2": `AdminModal_productionContent2__V4P7e`,
	"productionContentInfo": `AdminModal_productionContentInfo__65sPR`,
	"productionContentImage": `AdminModal_productionContentImage__KOzpR`,
	"contentInfoContainer": `AdminModal_contentInfoContainer__idT+1`,
	"contentImageContainer": `AdminModal_contentImageContainer__ijR-T`,
	"productionContentTheme": `AdminModal_productionContentTheme__J7kc0`,
	"productionContentMent": `AdminModal_productionContentMent__3hFhW`,
	"infoItemContainer": `AdminModal_infoItemContainer__YMSZl`,
	"infoItem": `AdminModal_infoItem__tlDn4`,
	"required": `AdminModal_required__WBXTo`,
	"imfoImage": `AdminModal_imfoImage__vAlM-`,
	"productionImage": `AdminModal_productionImage__sN95S`,
	"productionPlus": `AdminModal_productionPlus__-Cflz`,
	"isalbum": `AdminModal_isalbum__viRdH`,
	"introNewsBtn": `AdminModal_introNewsBtn__u601z`,
	"news": `AdminModal_news__UZhnl`,
	"notice": `AdminModal_notice__F5EN-`,
	"newsContent": `AdminModal_newsContent__HE0-P`,
	"newsContentItem": `AdminModal_newsContentItem__MMl74`,
	"newsContentThemeContainer": `AdminModal_newsContentThemeContainer__RuYyZ`,
	"newsContentTheme": `AdminModal_newsContentTheme__e-1DT`,
	"newsContentexplain": `AdminModal_newsContentexplain__kcOh5`,
	"requirednews": `AdminModal_requirednews__Ugryr`,
	"newsImgContainer": `AdminModal_newsImgContainer__3ey-z`,
	"newsImgAddBtn": `AdminModal_newsImgAddBtn__uWNU6`,
	"newsUploadImg": `AdminModal_newsUploadImg__NPM8h`,
	"newsUploadImgDelBtn": `AdminModal_newsUploadImgDelBtn__w6bh-`,
	"newsFileContainer": `AdminModal_newsFileContainer__Oxjjd`,
	"introMoreContainer": `AdminModal_introMoreContainer__nfeaY`,
	"introArtistContainer": `AdminModal_introArtistContainer__cMNg7`,
	"artist": `AdminModal_artist__7wiAg`,
	"middleArtistWrap": `AdminModal_middleArtistWrap__FseUU`,
	"middleArtist": `AdminModal_middleArtist__c+8Gj`,
	"artistContent": `AdminModal_artistContent__d0bXi`,
	"artistListContainer": `AdminModal_artistListContainer__44syX`,
	"artistListItem": `AdminModal_artistListItem__7E2uA`,
	"artistListItemNum": `AdminModal_artistListItemNum__yxj62`,
	"artistListItemName": `AdminModal_artistListItemName__ZRZdA`,
	"artistContent2": `AdminModal_artistContent2__5os1W`,
	"artistContentInfo": `AdminModal_artistContentInfo__+L850`,
	"artistContentInfoContainer": `AdminModal_artistContentInfoContainer__IEuSi`,
	"artistContentTheme": `AdminModal_artistContentTheme__jXWyR`,
	"aritstContentExplain": `AdminModal_aritstContentExplain__94hHK`,
	"artistContentImage": `AdminModal_artistContentImage__RL4y3`,
	"artistImgContainer": `AdminModal_artistImgContainer__tf3RB`,
	"artistImgItem": `AdminModal_artistImgItem__gZMpS`,
	"artistImgWithDel": `AdminModal_artistImgWithDel__-bOSJ`,
	"itemNameTag": `AdminModal_itemNameTag__fcmp6`,
	"artistPlus": `AdminModal_artistPlus__KOUSN`,
	"plusShape2": `AdminModal_plusShape2__8rPuJ`,
	"artistContentCareer": `AdminModal_artistContentCareer__+oPM-`,
	"artistCareerContainer": `AdminModal_artistCareerContainer__lElsF`,
	"artistCareerItem": `AdminModal_artistCareerItem__nnTZX`,
	"artistCareerTextarea": `AdminModal_artistCareerTextarea__xsZ8K`,
	"contentImageContainer2": `AdminModal_contentImageContainer2__R12Vr`,
	"productionContentTheme2": `AdminModal_productionContentTheme2__t4Aaw`,
	"producerImage": `AdminModal_producerImage__onvhD`,
	"productionContentInfo2": `AdminModal_productionContentInfo2__8Dn+6`,
	"productionContent3": `AdminModal_productionContent3__1EiSe`,
	"productionContentMent2": `AdminModal_productionContentMent2__q9ycL`,
	"producerTextContainer": `AdminModal_producerTextContainer__2yC5m`,
	"producerItem": `AdminModal_producerItem__yP50W`,
	"producerPlus": `AdminModal_producerPlus__DdSFb`
};
export default ___CSS_LOADER_EXPORT___;
